export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "LINK": {
          "LABEL": {
            "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Label"])},
            "PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter a label"])},
            "VALIDATION": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["Label is too long. ", _interpolate(_named("x")), " characters are allowed"])}
          },
          "TYPE": {
            "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Type"])},
            "PLACEHOLDER": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a type"])}
          },
          "URL": {
            "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Link"])},
            "PLACEHOLDER": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["Enter a ", _linked("LINK.CAP.SING", undefined, _type)])},
            "VALIDATION": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["The ", _linked("LINK.CAP.SING", undefined, _type), " is not valid. Expected format: https://example.com"])}
          },
          "CREATION_ERROR_URL": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["The ", _linked("LINK.CAP.SING", undefined, _type), " is not valid. Expected format: https://example.com"])}
        },
        "FORMAT": {
          "LABEL": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Format"])}
        },
        "FILE_LABEL": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize(["Drop your ", _linked("FILE.LOW.SING", undefined, _type), " here"])}
      }
    }
  })
}
